// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Bvy4","info":"Note_info__QCBH4","note":"Note_note__2a1Pv","actions":"Note_actions__KrXtA"};